import { makeAutoObservable } from 'mobx'

export class UiStore {
  uiHeight: number
  Content_Left_Width: number
  Coutent_Right_Width: number
  SearchPartShow = true
  isClickRural = false

  constructor() {
    makeAutoObservable(this)
    this.uiHeight = window.innerHeight
    this.Content_Left_Width = window.SystemConfig.uiConfig.Content_Left_Width
    this.Coutent_Right_Width = window.innerWidth - window.SystemConfig.uiConfig.Content_Left_Width
  }

  getUiHeight(e: any) {
    this.uiHeight = e.target.innerHeight - window.SystemConfig.uiConfig.headerHeight + window.SystemConfig.uiConfig.footerHeight
    this.Coutent_Right_Width = e.target.innerWidth - window.SystemConfig.uiConfig.Content_Left_Width
  }

  setCustomHeight(height: number) {
    this.uiHeight = height
  }

  searchPartHide() {
    this.SearchPartShow = !this.SearchPartShow
  }

  setSearchPartShow() {
    this.SearchPartShow = true
  }

  showRuralBusiness(flag: boolean) {
    this.isClickRural = flag
    this.SearchPartShow = true
  }
}
